import App from '@/App.vue'
import '@/styles/main.scss'
import { createApp } from 'vue'
import 'quill/dist/quill.snow.css'
import { createPinia } from 'pinia'
import { i18n } from './plugins/i18n'
import * as Sentry from "@sentry/vue"
import Tooltip from 'primevue/tooltip'
import PrimeVue from 'primevue/config'
import router from '@/router/router.ts'
import { createYmaps } from 'vue-yandex-maps'
import ToastService from 'primevue/toastservice'
import { options } from './plugins/PrimeVue/config'
import ConfirmationService from 'primevue/confirmationservice'
import { isChunkLoadError, isHandledByChunkReload, reloadForFreshChunks } from '@/utils/chunkReload'
import { patchInputMaskCaret } from './plugins/PrimeVue/inputMask/patchCaret'

patchInputMaskCaret()

window.addEventListener('vite:preloadError', event => {
    const error = (event as Event & { payload?: unknown }).payload
    if (isChunkLoadError(error)) reloadForFreshChunks()
})

const pinia = createPinia()
const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://2e56bacf6e2c2012b13cf14301693888@sentry.multidev.uz/21",
  sendDefaultPii: true,
  beforeSend(event, hint) {
    if (isHandledByChunkReload(hint.originalException)) return null
    return event
  }
})

app.use(i18n)
    .use(pinia)
    .use(router)
    .use(
        createYmaps({
            apikey: import.meta.env.VITE_YANDEX_MAPS_API_KEY ?? ''
        })
    )
    .use(PrimeVue, options)
    .use(ToastService)
    .use(ConfirmationService)
    .directive('tooltip', Tooltip)
    .mount('#app')

app.config.globalProperties.$tl = i18n.global.t
